import React, { useEffect, useRef } from "react";
import { Card, Flex, Typography } from "antd";
import Chart from "react-apexcharts";

export default function MonthlyRevenue() {
  return (
    <Card>
      <Flex vertical gap={30}>
        <Typography.Title level={4} style={{ marginBottom: 0 }}>
          Monthly Revenue
        </Typography.Title>
        <Typography.Title level={3} style={{ color: "#6b43b5", marginBottom: 0, marginTop: 0 }}>
          $850,000
        </Typography.Title>
        <MonthlyRevenueChart />
      </Flex>
    </Card>
  );
}

function MonthlyRevenueChart() {
  const chartRef = useRef(null);

  // Trigger resize after mount and when tab becomes visible
  useEffect(() => {
    const timer = setTimeout(() => {
      if (chartRef.current && chartRef.current.chart) {
        chartRef.current.chart.resize();
      }
    }, 100); // Small delay to ensure layout is ready

    return () => clearTimeout(timer);
  }, []);

  const series = [
    {
      name: "Revenue",
      data: [
        100, 250, 400, 800, 1200, 1600, 1800, 1850, 1820, 1780, 1700, 1650, 1550, 1450, 1350, 1250, 1150, 1050, 950, 850, 750, 650, 550, 450, 400,
        350, 300, 250, 200, 150, 100,
      ],
    },
  ];

  const options = {
    chart: {
      type: "area",
      height: 250,
      toolbar: { show: false },
      zoom: { enabled: false },
      sparkline: { enabled: false },
      animations: { enabled: true },
      parentHeightOffset: 0,
      offsetX: 0,
      offsetY: 0,
      dropShadow: {
        enabled: true,
        top: -2,
        left: 2,
        blur: 5,
        opacity: 0.06,
      },
    },
    stroke: {
      curve: "smooth",
      width: 3,
      colors: ["#722ED1"],
      shadow: {
        enabled: true,
        color: "#722ED1",
        top: 3,
        left: 0,
        blur: 8,
        opacity: 0.4,
      },
    },
    fill: {
      type: "gradient",
      gradient: {
        shadeIntensity: 0.5,
        opacityFrom: 1,
        opacityTo: 1,
        stops: [0, 90],
        colorStops: [
          {
            offset: 0,
            color: "#AD9EE7", // Light blue at the top
            opacity: 0.6,
          },
          {
            offset: 90,
            color: "#ffffff", // Fade to white at bottom
            opacity: 0.05,
          },
        ],
      },
    },
    markers: {
      size: 5,
      colors: ["#FFFFFF"],
      strokeColors: ["#722ED1"],
      strokeWidth: 2,
      hover: { size: 6 },
    },
    dataLabels: { enabled: false },
    xaxis: {
      type: "category",
      categories: Array.from({ length: 31 }, (_, i) => i),
      tickPlacement: "on",
      labels: {
        show: true,
        style: { colors: "#9098B1", fontSize: "12px" },
        formatter: (val) => {
          const ticks = [0, 2, 6, 10, 14, 18, 22, 26, 30];
          return ticks.includes(Number(val)) ? val : "";
        },
        rotate: 0,
        hideOverlappingLabels: true,
      },
      axisBorder: { show: false },
      axisTicks: { show: true },
    },
    yaxis: {
      min: 0,
      max: 2000,
      tickAmount: 4,
      labels: {
        style: { colors: "#9098B1", fontSize: "12px" },
        formatter: (v) => v.toLocaleString(),
        offsetX: -4,
      },
    },
    grid: {
      show: true,
      borderColor: "#F0F0F0",
      xaxis: { lines: { show: false } },
      yaxis: { lines: { show: true } },
    },
    tooltip: {
      x: { show: false },
      y: { formatter: (v) => "$" + v.toLocaleString() },
    },
    legend: { show: false },
  };

  return (
    <div
      style={{
        marginTop: "-20px",
        width: "100%",
        overflow: "visible",
      }}
    >
      <Chart
        options={options}
        series={series}
        ref={chartRef}
        type="area"
        height={250}
        width="100%" // Let container decide width
      />
    </div>
  );
}
